 $(document).ready(function(){
   $('.slider').slick({
     dots: true,
     easing: 'ease-in-out',
     infinite: false,
     fade: true
      });
    });